module.exports = {
  FORM_ERROR_CLASS_NAME: 'has-form-error'
}
